import { Alert } from 'reactstrap'
import CSVLink from '../CSVLink/CSVLink'

export default function LargeRowHandler({csvUrl, resultsLength}) {
  if (resultsLength === 20000) {
    return (
      <Alert style={{ textAlign: 'center', margin: '10px', fontSize: 'large' }} color='danger'>
      The report output has exceeded the maximum of 20,000 display rows.<br />
      Use the "Export To Spreadsheet" button below to retreive all rows.<br/>
        <CSVLink url={csvUrl} />
      </Alert>
    )
  } 
  return <CSVLink url={csvUrl} />
}